export class PrepaidExpenses {
  constructor() {
    this.interimInterestDays = 15;
    this.interimInterestAmount = 212;
    this.homeownersInsuranceMonths = 3;
    this.homeownersInsuranceAmount = 88;
    this.homeownersInsurancePrepaidMonths = 12;
    this.homeownersInsurancePrepaidAmount = 350;
    this.hoaDuesMonths = 2;
    this.hoaDues = 0;
    this.pmiMonths = 0;
    this.pmiAmount = 0;
    this.floodInsEscrowMonths = 3;
    this.floodInsEscrowAmount = 0;
    this.taxEscrowMonths = 3;
    this.taxEscrowAmount = 175;
  }
}
